/*eslint-disable no-undef */
import phina from 'phina.js'

export default ()=>{

  phina.define('MyDisplayScene', {
    superClass: 'phina.display.DisplayScene',
    init: function(param){
      // var self = this;
      param=(param||{}).$safe(MyDisplayScene.defaults);
      this.superInit(param);
  
      this.layout = phina.display.DisplayElement()
      .setPosition(0,0)
      .setScale(param.scale,param.scale)
      .addChildTo(this);

      this.addChild = this.addChildToMainWindow;
    },
    addChildToMainWindow: function(child){
      this.layout.addChild(child);
    },
    _static:{
      defaults:{
        width:1000, height:600,
        scale:1.0,
      }
    }
  });
  
}
